<template>
  <div class="repayment-container">
    <!-- 悬浮头部 -->
    <div class="sticky-header">
      <header class="header">
        <p class="header-title">My Loan</p>
        <button
          class="header-button"
          @click="goRolloverPae()"
          v-if="repayment.dueDate != null && repayment.remainAmount != null"
        >
          Extension Payment
        </button>
      </header>

      <!-- 悬浮状态卡片 -->
      <div
        class="card status-card"
        style="margin-top: 10px"
        v-if="repayment.dueDate != null"
      >
        <div
          class="status-indicator"
          :class="repayment.remainingDays > 0 ? 'on-time' : 'overdue'"
        >
          <span class="days-count">{{
            Math.abs(repayment.remainingDays)
          }}</span>
          <span class="days-label">{{
            repayment.remainingDays > 0 ? "Remaining days" : "Days overdue"
          }}</span>
        </div>

        <div class="status-details">
          <div class="detail-item">
            <span class="detail-value"
              >${{ formatAmount(repayment.remainAmount, 0, ".", ".") }}</span
            >
            <span class="detail-label">Amount to pay</span>
          </div>
          <div class="detail-item">
            <span class="detail-value">{{
              formatDate(repayment.dueDate)
            }}</span>
            <span class="detail-label">Due date</span>
          </div>
        </div>
      </div>

      <!-- Loan closed message -->
      <div
        class="card status-card loan-closed-card"
        style="margin-top: 10px; text-align: center;"
        v-if="loanClosed"
      >
        <div class="loan-closed-message">
          <p style="font-size: 16px; font-weight: 700; margin-bottom: 6px; color: #16F3C9;">
            Loan successfully closed
          </p>
          <p style="font-size: 14px; color: #B4E4DC; margin: 0;">
            You can apply for a higher amount next time.
          </p>
        </div>
      </div>
    </div>

    <main class="content">
      <!-- 贷款详情卡片 -->
      <div
        class="card info-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
      >
        <div class="info-row">
          <span>Móvil</span>
          <span
            >***
            {{ repayment.phone.substr(5, repayment.phone.length - 1) }}</span
          >
        </div>

        <div class="info-row">
          <span>Status</span>
          <span class="status-badge">Prepare to pay</span>
        </div>

        <div class="info-row">
          <span>Account holder:</span>
          <span>{{ repayment.titular }}</span>
        </div>

        <!-- Pay now button -->
        <div style="margin-top: 20px; text-align: center;">
          <button
            class="primary-btn"
            @click="copyCLABE"
            style="width: 100%; max-width: 320px;"
          >
            Pay now →
          </button>
        </div>
      </div>

      <!-- 无到期日时的卡片 -->
      <div
        class="card advice-card"
        v-if="repayment.dueDate == null && repayment.remainAmount != null"
      >
        <p class="advice-text">
          Maintain and take care of your credit, it would avoid an extra charge
          for the delay. We suggest making the payment with the following
          accounts:
        </p>
        <div class="info-row">
          <span>Account holder:</span>
          <span>{{ repayment.titular }}</span>
        </div>
      </div>

      <!-- Safe Repayment Reminder -->
      <div
        class="card warning-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
      >
        <div style="display: flex; align-items: flex-start;">
          <span class="warning-icon">⚠️</span>
          <div>
            <p class="warning-title">
              Safe Repayment Reminder
            </p>
            <p class="warning-desc">
              Always repay using the UPIID shown in this App.
            </p>
            <p class="warning-desc" style="margin-bottom: 0;">
              Do NOT trust any UPIID shared in WhatsApp or personal messages.
            </p>
          </div>
        </div>
      </div>

      <!-- UTR Input Section -->
      <div
        class="card utr-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
      >
        <div class="utr-input-container">
          <label class="utr-label">Enter UTR Number</label>
          <p class="utr-desc">
            After completing payment, please enter your 12-digit UTR(UPI Ref.
            No.) below ↓
          </p>
          <div class="input-wrapper">
            <input
              v-model="utr"
              class="utr-input"
              type="text"
              placeholder="Enter 12-digit UTR number"
              maxlength="12"
            />
            <button class="paste-btn" @click="pasteUTR">Paste</button>
          </div>
          <div class="error-message" v-if="utr && !isValidUTR()">
            Please enter a valid 12-digit UTR number
          </div>

          <!-- Success message - only shown after successful submission -->
          <div class="success-message" v-if="utrSubmitted && utrSuccessMessage">
            {{ utrSuccessMessage }}
          </div>

          <button
            class="submit-utr-btn"
            @click="submitUTR"
            :disabled="!isValidUTR()"
          >
            Submit UTR →
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import CallApp from "callapp-lib";

export default {
  name: "Repayment",
  data() {
    return {
      repayment: {},
      bankMethods: {},
      repaymentCode: null,
      key: "",
      clabe: null,
      instance: null,
      showBankSelection: false,
      expandedCategories: {},
      utr: "",
      utrSubmitted: false,
      utrSuccessMessage: "",
      loanClosed: false,
    };
  },
  mounted() {
    document.title = "My Loan";
  },
  created() {
    this.getDetailInfo();
  },
  methods: {
    formatDate(dateStr) {
      return dateStr ? dateStr.substr(0, 10) : "";
    },

    penaltyWaiver() {
      if (this.repayment.penaltyUrl) {
        window.open(this.repayment.penaltyUrl, "_blank");
        let keyStr = this.getParamQueryString(window.location.href, "key");
        this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "open_penalty_waiver",
          },
          true,
        );
      }
    },
    formatAmount(
      amount,
      decimals = 2,
      decimalSeparator = ".",
      thousandSeparator = ",",
    ) {
      amount = Number(amount);
      if (isNaN(amount)) {
        return "";
      }
      const factor = Math.pow(10, decimals);
      amount = Math.round(amount * factor) / factor;
      let amountStr = amount.toFixed(decimals);
      const [integerPart, decimalPart] = amountStr.split(".");
      const integerPartWithSeparator = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        thousandSeparator,
      );
      return (
        integerPartWithSeparator +
        (decimalPart ? decimalSeparator + decimalPart : "")
      );
    },
    async getDetailInfo() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      let res = await this.$Http.getRepaymentInfo({ key: keyStr }, true);
      this.repayment = res;

      if (res.dueDate == null && res.remainAmount == null) {
        this.loanClosed = true;
      }

      try {
        let bankRes = await this.$Http.repaymentMethod({ key: keyStr });
        this.bankMethods = {
          "Payment Methods": Object.keys(bankRes).map((key) => ({
            repayCode: key,
            repayMethodName: key,
            selected: bankRes[key],
          })),
        };
        Object.keys(bankRes).map((key) => {
          if (bankRes[key]) {
            this.repaymentCode = key;
          }
        });
        this.initExpandedState();
      } catch (error) {
        console.error("Error fetching bank methods:", error);
      }
    },
    getParamQueryString(url, name) {
      let subStr = name + "=";
      if (url.indexOf(subStr) !== -1) {
        let arr = url.split(subStr);
        let sub1 = arr[1];
        if (sub1.indexOf("&") !== -1) {
          let arr2 = sub1.split("&");
          return arr2[0];
        }
        return sub1;
      }
      return "";
    },
    goRolloverPae() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      this.$router.push({ path: "/rollover", query: { key: keyStr } });
    },
    async copyCLABE() {
      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let responseInfo = await this.$Http.repaymentUrl(
          {
            key: keyStr,
            repayCode: this.repaymentCode,
          },
          false,
        );
        if (responseInfo && responseInfo.length > 0) {
          window.open(responseInfo, "_blank");
        }
        await this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "click_pay_button",
          },
          true,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    },
    initExpandedState() {
      const categories = Object.keys(this.bankMethods);
      let selectedCategory = null;
      selectedCategory = categories[0];

      categories.forEach((category) => {
        const methods = this.bankMethods[category];
        const hasSelected = methods.some((method) => method.selected);
        if (hasSelected) {
          selectedCategory = category;
        }
      });

      categories.forEach((category) => {
        this.$set(this.expandedCategories, category, false);
      });

      if (selectedCategory) {
        this.$set(this.expandedCategories, selectedCategory, true);
        this.lastExpandedCategory = selectedCategory;
      } else if (categories.length > 0) {
        this.$set(this.expandedCategories, categories[0], true);
        this.lastExpandedCategory = categories[0];
      }
    },
    toggleCategory(category) {
      if (this.expandedCategories[category]) {
        this.$set(this.expandedCategories, category, false);
        this.lastExpandedCategory = null;
      } else {
        if (this.lastExpandedCategory) {
          this.$set(this.expandedCategories, this.lastExpandedCategory, false);
        }
        this.$set(this.expandedCategories, category, true);
        this.lastExpandedCategory = category;
      }
    },
    selectMethod(method) {
      Object.keys(this.bankMethods).forEach((category) => {
        this.bankMethods[category].forEach((m) => {
          this.$set(m, "selected", false);
        });
      });

      this.$set(method, "selected", true);
      this.repaymentCode = method.repayCode;
      const bankName = method.repayMethodName.includes("-")
        ? method.repayMethodName.split("-")[0]
        : method.repayMethodName;
      this.repayment.repaymentBankName = bankName;
      this.showBankSelection = false;
    },
    isValidUTR() {
      return /^\d{12}$/.test(this.utr);
    },
    async pasteUTR() {
      try {
        const text = await navigator.clipboard.readText();
        if (/^\d{12}$/.test(text)) {
          this.utr = text;
        } else {
          this.utr = text;
        }
      } catch (err) {
        console.error("Failed to read clipboard contents: ", err);
      }
    },
    async submitUTR() {
      if (!this.isValidUTR()) {
        return;
      }

      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let response = await this.$Http.submitUrl(
          {
            key: keyStr,
            utr: this.utr,
            isExtend: false,
          },
          true,
        );

        console.log("UTR submitted successfully", response);

        if (this.$toast) {
          this.$toast.success("Success");
        } else {
          alert("Success");
        }

        if (response && response.loanClosed) {
          this.loanClosed = true;
          if (this.$toast) {
            this.$toast.success(
              "Loan successfully closed. You can apply for a higher amount next time.",
            );
          }
        } else if (
          response &&
          response.dueDate == null &&
          response.remainAmount == null
        ) {
          this.loanClosed = true;
          if (this.$toast) {
            this.$toast.success(
              "Loan successfully closed. You can apply for a higher amount next time.",
            );
          }
        }

        this.utrSubmitted = true;
        this.utrSuccessMessage =
          response.message || "UTR submitted successfully!";
      } catch (error) {
        console.error("Error submitting UTR:", error);
        this.utrSubmitted = false;
        this.utrSuccessMessage = "";

        if (this.$toast) {
          this.$toast.fail("Failed to submit UTR");
        }
      }
    },
  },
};
</script>

<style scoped>
/* 基础容器：透明（继承全局极光背景） */
.repayment-container {
  min-height: 100vh;
  background-color: transparent;
  color: #FFFFFF;
  padding-bottom: 40px;
}

/* 悬浮头部区域 */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: transparent;
}

/* 头部样式：Credit Scope 深翠绿渐变 Header */
.header {
  background: linear-gradient(180deg, rgba(20, 84, 73, 0.96) 0%, rgba(14, 62, 54, 0.92) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  color: #FFFFFF;
  padding: 18px 20px 48px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 24px 24px;
  border-bottom: 1px solid rgba(22, 243, 201, 0.3);
  box-shadow: 0 10px 30px rgba(10, 45, 39, 0.45), 0 0 20px rgba(22, 243, 201, 0.08);
}

.header-title {
  font-size: 20px;
  font-weight: 800;
  flex: 1;
  text-align: left;
  letter-spacing: 0.2px;
  margin: 0;
  color: #FFFFFF;
}

.header-button {
  background: rgba(22, 243, 201, 0.14);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1.5px solid #16F3C9;
  color: #16F3C9;
  font-size: 13px;
  font-weight: 700;
  padding: 7px 16px;
  border-radius: 20px;
  cursor: pointer;
  letter-spacing: 0.5px;
  box-shadow: 0 0 12px rgba(22, 243, 201, 0.3);
  transition: all 0.2s ease;
}

.header-button:active {
  transform: scale(0.95);
  background: rgba(22, 243, 201, 0.28);
  box-shadow: 0 0 18px rgba(22, 243, 201, 0.5);
}

/* 卡片通用样式：深翠玉磨砂玻璃拟态 + 亮青边缘微光 */
.card {
  background: rgba(14, 64, 56, 0.78);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 20px;
  max-width: 600px;
  box-shadow: 0 14px 36px rgba(10, 45, 39, 0.42), 0 0 18px rgba(22, 243, 201, 0.08);
  border: 1px solid rgba(22, 243, 201, 0.3);
  margin: 0 16px 16px;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

/* 状态卡片 (浮动在Header下方) */
.status-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  background: rgba(16, 70, 62, 0.88);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  color: #FFFFFF;
  margin-top: -36px;
  position: relative;
  z-index: 10;
  border: 1px solid rgba(22, 243, 201, 0.38);
  box-shadow: 0 14px 40px rgba(10, 45, 39, 0.5), 0 0 25px rgba(22, 243, 201, 0.15);
}

.status-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px 0 4px;
  border-right: 1px solid rgba(22, 243, 201, 0.2);
  min-width: 105px;
}

.days-count {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.5px;
}

.status-indicator.on-time .days-count {
  color: #16F3C9;
  text-shadow: 0 0 14px rgba(22, 243, 201, 0.6);
}

.status-indicator.overdue .days-count {
  color: #FF5C6E;
  text-shadow: 0 0 12px rgba(255, 92, 110, 0.5);
}

.days-label {
  font-size: 12px;
  margin-top: 6px;
  color: #B4E4DC;
  font-weight: 600;
}

.status-details {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-value {
  font-size: 18px;
  font-weight: 800;
  color: #FFFFFF;
  margin-bottom: 4px;
  margin-top: 4px;
}

.detail-label {
  font-size: 12px;
  color: #B4E4DC;
  font-weight: 500;
}

/* 内容区域 */
.content {
  padding-bottom: 120px;
  max-width: 600px;
  margin: 0 auto;
}

/* 信息卡片 */
.info-card {
  padding: 20px;
  margin: 16px 16px 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background-color: rgba(9, 48, 41, 0.68);
  border-radius: 14px;
  margin-bottom: 10px;
  border: 1px solid rgba(22, 243, 201, 0.18);
  font-size: 14px;
  color: #B4E4DC;
  font-weight: 500;
}

.info-row span:last-child {
  font-weight: 700;
  color: #FFFFFF;
}

.status-badge {
  background-color: rgba(22, 243, 201, 0.18);
  color: #16F3C9;
  border: 1px solid rgba(22, 243, 201, 0.45);
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 0 10px rgba(22, 243, 201, 0.25);
}

/* 建议卡片 & 提醒卡片 */
.advice-card {
  padding: 20px;
  margin: 0 16px 16px;
}

.advice-text {
  margin-bottom: 14px;
  line-height: 1.5;
  color: #B4E4DC;
  font-size: 14px;
}

.warning-card {
  padding: 18px 20px;
  margin: 16px 16px 16px;
  background: rgba(16, 70, 62, 0.82) !important;
  border: 1px solid rgba(22, 243, 201, 0.35) !important;
  border-radius: 16px !important;
  box-shadow: 0 8px 24px rgba(10, 45, 39, 0.4) !important;
}

.warning-icon {
  font-size: 18px;
  color: #16F3C9;
  margin-right: 10px;
}

.warning-title {
  font-weight: 700;
  margin: 0 0 6px 0;
  color: #16F3C9;
  font-size: 15px;
}

.warning-desc {
  margin: 0 0 4px 0;
  font-size: 13px;
  color: #B4E4DC;
  line-height: 1.4;
}

/* UTR Input Styles */
.utr-card {
  padding: 20px;
  margin: 0 16px 20px;
}

.utr-label {
  display: block;
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #FFFFFF;
}

.utr-desc {
  font-size: 13px;
  color: #B4E4DC;
  margin: 0 0 14px 0;
  line-height: 1.4;
}

.input-wrapper {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.utr-input {
  flex: 1;
  padding: 12px 16px;
  background-color: rgba(9, 46, 40, 0.75);
  border: 1px solid rgba(22, 243, 201, 0.28);
  border-radius: 14px;
  font-size: 15px;
  outline: none;
  color: #FFFFFF;
  font-weight: 600;
  transition: all 0.2s;
}

.utr-input:focus {
  border-color: #16F3C9;
  background-color: rgba(12, 56, 48, 0.9);
  box-shadow: 0 0 0 3px rgba(22, 243, 201, 0.28), 0 0 16px rgba(22, 243, 201, 0.25);
}

.utr-input::placeholder {
  color: #72A69E;
  font-weight: normal;
}

.paste-btn {
  background-color: rgba(22, 243, 201, 0.16);
  border: 1px solid rgba(22, 243, 201, 0.4);
  border-radius: 12px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 700;
  color: #16F3C9;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 0 12px rgba(22, 243, 201, 0.18);
}

.paste-btn:active {
  transform: scale(0.95);
  background-color: rgba(22, 243, 201, 0.32);
}

.error-message {
  color: #FF5C6E;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
}

.success-message {
  color: #16F3C9;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
  text-shadow: 0 0 10px rgba(22, 243, 201, 0.45);
}

/* 主行动按钮：Credit Scope 发光按钮风格 (深青内底 + 亮青霓虹发光描边 + 白字加粗科技字体) */
.primary-btn,
.submit-utr-btn {
  position: relative;
  width: 100%;
  background: linear-gradient(180deg, #14594D 0%, #0D3E36 100%);
  color: #FFFFFF;
  border: 1.5px solid #16F3C9;
  border-radius: 16px;
  padding: 15px;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 0 18px rgba(22, 243, 201, 0.4), 0 8px 24px rgba(10, 45, 39, 0.45), inset 0 0 12px rgba(22, 243, 201, 0.18);
  letter-spacing: 0.8px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.primary-btn::before,
.submit-utr-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 40%;
  background: linear-gradient(180deg, rgba(22, 243, 201, 0.22) 0%, transparent 100%);
  border-radius: 14px 14px 0 0;
  pointer-events: none;
}

.primary-btn:hover,
.submit-utr-btn:hover:not(:disabled) {
  border-color: #2DFBD3;
  box-shadow: 0 0 26px rgba(22, 243, 201, 0.65), 0 10px 28px rgba(10, 45, 39, 0.5), inset 0 0 16px rgba(22, 243, 201, 0.3);
  transform: translateY(-1px);
}

.primary-btn:active,
.submit-utr-btn:active:not(:disabled) {
  transform: scale(0.98);
  opacity: 0.94;
  box-shadow: 0 0 14px rgba(22, 243, 201, 0.35);
}

.submit-utr-btn:disabled {
  background: rgba(14, 58, 50, 0.6);
  border-color: rgba(22, 243, 201, 0.18);
  color: #72A69E;
  box-shadow: none;
  cursor: not-allowed;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .status-card {
    flex-direction: row;
  }
}
</style>
